<template>
	<page-template>
		<div class="wpusers_toolbar">
			<!-- <select class="ui dropdown" v-model="filterLogicalOperation">
        <option disabled value="">필터 로직</option>
        <option value="0">and</option>
        <option value="1">or</option>
			</select>-->
			<select class="ui dropdown" v-model="filterField">
				<option disabled value>필터 항목</option>
				<option selected="selected" value="name">이름</option>
				<option value="phone">전화번호</option>
				<option value="email">이메일</option>
				<option value="id">id</option>
			</select>
			<div class="spacer"></div>
			<select class="ui dropdown" v-model="filterOperator">
				<option disabled value>필터 연산자</option>
				<option value="like">포함하는</option>
				<option value="=">=</option>
			</select>
			<div class="spacer"></div>
			<div class="ui input">
				<input type="text" placeholder="value" v-model="filterValue" v-on:keyup.enter="filter" />
			</div>
			<div class="spacer"></div>
			<button class="ui button primary" @click="filter" :disabled="cannotFilter">필터 검색</button>
			<div class="spacer"></div>
			<button class="ui button negative" @click="resetFilter">필터 리셋</button>
			<div class="spacer"></div>
			<button @click="exportCSV">export CSV</button>
			<input type="checkbox" id="checkbox" v-model="check_sms_permitted" />
			<label for="checkbox">SMS 동의</label>
		</div>

		<!-- <button-text 
              class="row-button"
              :callback="exportCSV"
              :is-type="1">

      <span class="text">내려 받기</span>
		</button-text>-->

		<board
			:is-fold="isFold"
			:http-options="httpOptions"
			:config="config"
			:play-button-function="callModalSignupConfirm"
			:disabled-modify-button="true"
			:disabled-delete-button="true"
			:disabled-play-button="true"
			:disabled-search-button="true"
		/>
		<iframe id="my_iframe" style="display:none;"></iframe>
	</page-template>
</template>

<script>
import Vue from "vue";
import axios from "axios";

import config from "./Config";

import UserManagementCustomActionComponent from "./custom-action-component/WpUserManagementCustomActionComponent";
import CommonBoardItems from "../CommonBoardItems";

Vue.component(
	"WpUserManagementCustomActionComponent",
	UserManagementCustomActionComponent
);

export default {
	name: "BoardWpUserManagement",
	methods: {
		async resetFilter() {
			this.filterLogicalOperation = "";
			this.filterField = "name";
			this.filterOperator = "like";
			this.filterValue = "";
			config.apiUrl = "/api/wp-users";
			this.$events.fire("filter-set");
		},
		async filter() {
			if (this.cannotFilter) return;
			console.log("filterLogicalOperation", this.filterLogicalOperation);
			console.log("filterField", this.filterField);
			console.log("filterOperator", this.filterOperator);
			console.log("filterValue", this.filterValue);

			let myOptions = JSON.parse(JSON.stringify(this.httpOptions));
			delete myOptions.params;
			console.log(this.httpOptions);
			let filter = [
				{
					field: this.filterField,
					operator: this.filterOperator,
					value: this.filterValue
				}
			];
			this.$events.fire("filter-set", JSON.stringify(filter));
			config.apiUrl = "/api/wp-users-filter";
			// const response = await axios.post("/api/wp-users", {
			//   	"filter" : [
			//       {
			//         "field" : this.filterField,
			//         "operator" : this.filterOperator,
			//         "value" : this.filterValue
			//       }
			//       ],
			//       "sort" : ""
			// }, myOptions);
			// console.log("response", response);
		},
		async exportCSV() {
			console.dir(this.httpOptions);
			let myOptions = JSON.parse(JSON.stringify(this.httpOptions));
			delete myOptions.params.per_page;
			let apiUrl = "";
			if (this.check_sms_permitted)
				apiUrl = "/api/wp-users/terms_noti_sms/true?per_page=all";
			else apiUrl = "/api/wp-users?per_page=all";

			console.log("apiUrl", apiUrl);
			const response = await axios.get(apiUrl, myOptions);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", response.headers.filename);
			document.body.appendChild(link);
			link.click();
		},
		callModalSignupConfirm(rowData) {
			this.$modal.changeToComponent(
				this.$modal.modalType.SignupConfirm,
				rowData
			);
		}
	},
	mixins: [CommonBoardItems],
	data() {
		return {
			config,
			check_sms_permitted: false,
			filterLogicalOperation: "",
			filterField: "name",
			filterOperator: "like",
			filterValue: ""
		};
	},
	computed: {
		cannotFilter() {
			if (this.filterField == null || this.filterField.length == 0) return true;
			if (this.filterOperator == null || this.filterOperator.length == 0)
				return true;
			if (this.filterValue == null || this.filterValue.length == 0) return true;
			return false;
		}
	},
	watch: {
		check_sms_permitted: value => {
			console.log("check_sms_permitted", value);
			if (value == true) {
				config.apiUrl = "/api/wp-users/terms_noti_sms/true";
			} else {
				this.filterLogicalOperation = "";
				this.filterField = "";
				this.filterOperator = "like";
				this.filterValue = "";
				config.apiUrl = "/api/wp-users";
				// this.$events.fire('filter-set', JSON.stringify(filter));
			}
		}
	}
};
</script>

<style>
.wpusers_toolbar {
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-bottom: 10px;
}
.wpusers_toolbar > input,
button {
	margin-left: 20px;
}
.wpusers_toolbar > label {
	margin-left: 6px;
}

.spacer {
	min-width: 10px;
}
</style>


// WEBPACK FOOTER //
// src/spa/components/board/wp-user-management/BoardWpUserManagement.vue